<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style lang="stylus">
html, body, #app {
  width: 100%;
  height: 100%;
  overflow: hidden; // 禁用页面的整体滚动
  font-family: PingFangSC-Semibold, PingFang SC;
}
</style>
